import { UserAgentSetting } from './UserAgentSetting';
import { UserAgentExchangePair } from './UserAgentExchangePair';

export class UserAgent {
  idUserAgent: number;
  idUserAccount: number;
  idAgent: number;
  locked: boolean;
  settings: UserAgentSetting[];
  exchangePairs: UserAgentExchangePair[];

  constructor(
    idUserAgent: number,
    idUserAccount: number,
    idAgent: number,
    locked: boolean,
    settings: UserAgentSetting[] = [],
    exchangePairs: UserAgentExchangePair[] = []
  ) {
    this.idUserAgent = idUserAgent;
    this.idUserAccount = idUserAccount;
    this.idAgent = idAgent;
    this.locked = locked;
    this.settings = settings;
    this.exchangePairs = exchangePairs;
  }

  static fromRaw(raw: any): UserAgent {
    return new UserAgent(
      Number(raw.idUserAgent),
      Number(raw.idUserAccount),
      Number(raw.idAgent),
      Boolean(raw.locked),
      Object.values(raw.userAgentSettings || {}).map(UserAgentSetting.fromRaw),
      Object.values(raw.userAgentExchangePairs || {}).map(UserAgentExchangePair.fromRaw)
    );
  }

  clone(): UserAgent {
    return new UserAgent(
      this.idUserAgent,
      this.idUserAccount,
      this.idAgent,
      this.locked,
      this.settings.map(setting => setting.clone()),
      this.exchangePairs.map(pair => pair.clone())
    );
  }

  toPayload(): any {
    const payload: any = {};
    
    // Добавляем idUserAgent только если он не 0
    if (this.idUserAgent !== 0) {
      payload.idUserAgent = this.idUserAgent;
    }
    
    payload.idUserAccount = this.idUserAccount;
    payload.idAgent = this.idAgent;
    
    // Не отправляем locked для создания (всегда false)
    if (this.locked) {
      payload.locked = this.locked;
    }
    
    // Упрощаем settings: объект где ключи = idAgentSetting, значения = value
    if (this.settings.length > 0) {
      payload.settings = {};
      this.settings.forEach(setting => {
        if (setting.idAgentSetting !== null) {
          payload.settings[setting.idAgentSetting] = setting.value;
        }
      });
    }
    
    // Упрощаем exchangePairs: только массив idExchangePair
    if (this.exchangePairs.length > 0) {
      payload.exchangePairs = this.exchangePairs.map(pair => pair.idExchangePair);
    }
    
    return payload;
  }
}
